import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LabLayoutComponent, type LabMenuItem } from '@dental-ui/lab-layout';
import { LAB_MENU_ITEMS } from '@dental-ui/shared/consts';

@Component({
  selector: 'app-lab-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LabLayoutComponent],
  template: `
    <lib-lab-layout 
    [menuItems]="menuItems" 
    appTitle="Lab Manager"
    >
      <router-outlet />
    </lib-lab-layout>
  `,
})
export class LabShellComponent {
  menuItems: LabMenuItem[] = LAB_MENU_ITEMS;
}
